/*
 * „Today's deals“ (sections/lp-daily-deals.liquid), Element <lp-daily-deals>:
 * - Countdown-Kacheln bis Mitternacht in der Shop-Zeitzone (data-offset wie +0200/-0700), dann wechselt die Auswahl.
 *   Die Kachel, deren Wert sich ändert, springt kurz (is-tick).
 * - Einblenden wie „Shop by mood“: is-armed, beim Sichtbarwerden is-in (Kreise wandern, Wellenlinie, Karten gestaffelt).
 *   Steht die Section beim Laden schon im Bild, spielt die Animation sofort. Reduzierte Bewegung: keine Animation.
 */
(() => {
  if (customElements.get('lp-daily-deals')) return;

  customElements.define('lp-daily-deals', class extends HTMLElement {
    connectedCallback() {
      this.initTimer();
      this.initReveal();
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      this.io?.disconnect();
    }

    initReveal() {
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window) || window.Shopify?.designMode) return;
      this.classList.add('is-armed');
      this.io = new IntersectionObserver((entries) => {
        if (!entries.some((e) => e.isIntersecting)) return;
        this.io.disconnect();
        requestAnimationFrame(() => this.classList.add('is-in'));
      }, { threshold: 0.2 });
      this.io.observe(this.querySelector('.lp-deals__band') || this);
    }

    initTimer() {
      const box = this.querySelector('.lp-deals__timer');
      const m = /^([+-])(\d{2})(\d{2})$/.exec(this.dataset.offset || '');
      if (!box || !m) return;
      const units = Object.fromEntries([...box.querySelectorAll('[data-u]')].map((b) => [b.dataset.u, b]));
      const offset = (m[1] === '-' ? -1 : 1) * (Number(m[2]) * 60 + Number(m[3])) * 60000;
      const pad = (n) => String(n).padStart(2, '0');
      const set = (el, value) => {
        if (el.textContent === value) return;
        el.textContent = value;
        el.classList.remove('is-tick');
        void el.offsetWidth;
        el.classList.add('is-tick');
      };
      const tick = () => {
        const left = Math.max(0, Math.floor((86400000 - ((Date.now() + offset) % 86400000)) / 1000));
        set(units.h, pad(Math.floor(left / 3600)));
        set(units.m, pad(Math.floor((left % 3600) / 60)));
        set(units.s, pad(left % 60));
      };
      tick();
      box.hidden = false;
      this.timer = setInterval(tick, 1000);
    }
  });
})();
